export const TOP_KPI = {
	PRODUCTS: 'products',
	DISPERSION: 'dispersion'
}